import React, { useState, useEffect } from "react";
import "./CarouselHome.css";
import Carousel from '../Carousel/Carousel';


const CarouselHome =(props) =>{
  const [carouselItems,setCarouselItems] = useState([]);
  const [containerBackgroundImage,setContainerBackgroundImage] = useState('');
  const [linkObj,setLinkObj] = useState({});

  useEffect(()=>{
    let tempLinkObj={};
    let tempBackground='';
    
    let tempItems = props.items.filter((item,idx)=>{
      if(item.MashanIsActive){
        
        if(!item.MashanContainerLink && !!item.MashanTopMobileImage && !!item.MashanTopMobileImage.ImageUrl){
          //background container image 
          tempBackground = item.MashanTopMobileImage.ImageUrl;
          return false;
        }
        else if(!item.MashanTopDesktopImage && !item.MashanTopDesktopImage
                  && !!item.MashanContainerLink && !!item.MashanContainerLink.NavigateUrl){
                    tempLinkObj=   item;

                    return false;
        }
        else{
           //return item;
           return true;
        }
      }


    });
    
    setCarouselItems(tempItems)
    setContainerBackgroundImage(tempBackground)
    setLinkObj(tempLinkObj)
  },[]);
  const CarouselBtnLink=(link)=>{
  //  console.log("link",link);
    window.location.href = link;
};  
  
    return (
          <div className="container-carousel-home-wrapper col-12 nav-section" id={`nav-section-0`}  
                style={{backgroundImage: !!containerBackgroundImage ? `url(${containerBackgroundImage}?RenditionID=11)`: ''}}>
       
            <div className="carousel-home-title-text col-11 col-md-12">
                <span className="col-11 col-md-12"> 
                  {props.title}
             </span> 
                 <Carousel items={carouselItems}/>  
                 <div className={'col-12 col-md-12'}>
                 {!!linkObj.MashanContainerLink &&
                      <button type='button' className='btn btn-primary carousel-btn col-12 col-md-6 col-xl-4'  onClick={(e)=>CarouselBtnLink(linkObj.MashanContainerLink.NavigateUrl)}>
                         {linkObj.MashanContainerLink.Text}
                        </button> }
                 </div>
            </div>
          </div>
    )
};


export default CarouselHome;